import { render, staticRenderFns } from "./group_mcp_servers_index.vue?vue&type=template&id=4b42ad5b"
import script from "./group_mcp_servers_index.vue?vue&type=script&lang=js"
export * from "./group_mcp_servers_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports